module.exports = __webpack_public_path__ + "static/media/thumbnail.fe6426d4.jpg";